<template>
    <div class="row">
      <div class="col">
        <div class="card card-modern">
          <div class="card-body">
            <div class="datatables-header-footer-wrapper">
              <div class="datatable-header">
                <div class="row mb-3">
                  <div
                    class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center"
                  >
                    <treeselect
                      v-model="companyId"
                      class="w-25 form-control form-control-modern bg-body"
                      loadingText="Učitavanje..."
                      noResultsText="Nema rezultata"
                      searchPromptText="Unesite naziv komitenta"
                      :load-options="loadCompanies"
                      :async="true"
                      :options="companies"
                      placeholder="Izaberite komitenta"
                    />
  
                    <treeselect
                      v-model="b2bOrb2c"
                      class="w-25 mx-1 form-control form-control-modern"
                      :options="b2bOrb2cOptions"
                      placeholder="B2B/B2C"
                    />
                  </div>
                  <div class="col-4 d-flex justify-content-end">
                    <div class="row col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                      <div
                        class="d-flex align-items-lg-center flex-column flex-lg-row"
                      >
                        <label class="ws-nowrap me-3 mb-0">Show:</label>
                        <select
                          class="form-control select-style-1 results-per-page"
                          name="results-per-page"
                          v-model="searchConfig.pageSize"
                          @change="changePageSize(searchConfig.pageSize)"
                        >
                          <option
                            :value="page"
                            v-for="page in pageSizeList"
                            :key="page"
                          >
                            {{ page }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-lg-auto ps-lg-1">
                      <div
                        class="search search-style-1 search-style-1-lg mx-lg-auto"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Search"
                            v-model="searchField"
                            @input="debounceInput"
                          />
                          <button class="btn btn-default" type="submit">
                            <i class="bx bx-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div
                class="dataTables_wrapper dt-bootstrap5 no-footer"
                v-if="list.length > 0"
              >
                <div class="table-responsive">
                  <table
                    class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                  >
                    <thead>
                      <tr role="row">
                        <th>Komitent</th>
                        <th>Ime i prezime</th>
                        <th>B2B/B2C</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-for="(wishList, index) in list"
                        :key="wishList.userId"
                        :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                        @click="openWishList(wishList.userId)"
                      >
                        <td>
                          {{ wishList.company || 'N/A' }}
                        </td>
                        <td>
                          {{ wishList.userFullName }}
                        </td>
                        <td>
                          <span
                            class="badge"
                            :class="[
                              wishList.b2B ? 'bg-light text-dark' : 'bg-dark',
                            ]"
                          >
                            {{ wishList.b2B ? 'B2B' : 'B2C' }}
                          </span>
                        </td>
                        <td>
                          <router-link
                            :to="{ name: 'EditWishList', params: { id: wishList.userId } }"
                          >
                            <span role="button">
                              <i class="fas fa-external-link-alt"></i>
                            </span>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }}
                  <a class="alert-link" @click.prevent="resetFilters">{{
                    translations.resetFilters
                  }}</a
                  >.
                </div>
              </div>
              <hr class="solid mt-5 opacity-4" />
              <div class="datatable-footer">
                <div class="row align-items-center justify-content-between mt-3">
                  <div class="row row-gutter-sm justify-content-between mt-4">
                    <pagination
                      :action="actionName"
                      :pagination-props="paginationProps"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import bs from 'vuejs-datepicker/dist/locale/translations/bs';
  
  import Treeselect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  
  import { translations, pager } from '@/mixins';
  import Pagination from '../shared/Pagination.vue';
  
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 15);
  export default {
    components: {
      Treeselect,
      Pagination,
    },
    name: 'WishLists',
    mixins: [translations, pager],
    data() {
      const { query } = this.$route;
  
      return {
        actionName: 'getWishLists',
        deleteActionName: 'toBeDefined',
        wishList: null,
        companyId: query?.companyId ? parseInt(query.companyId, 10) : null,
        b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
      };
    },
    computed: {
      bs() {
        return bs;
      },
      b2bOrb2cOptions() {
        return [
          { id: 'b2b', label: 'B2B' },
          { id: 'b2c', label: 'B2C' },
          { id: 'all', label: 'Sve' },
        ];
      },
      list() {
        return this.$store.getters.getWishLists;
      },
      companies() {
        const companies = this.$store.getters.getCompanies.map((item) => {
          return {
            id: item.id,
            label: item.title,
          };
        });
        return companies;
      },
      paginationProps() {
        return {
          companyId: this.companyId,
          orderStatus: this.orderStatus,
          b2b: this.b2bOrb2c === 'b2b' ? true : null,
          b2c: this.b2bOrb2c === 'b2c' ? true : null,
        };
      },
    },
    methods: {
      loadCompanies({ callback, searchQuery }) {
        this.$store
          .dispatch('getCompanies', {
            isSortAscending: true,
            retrieveAll: true,
            quickSearch: searchQuery,
            sortBy: 'title',
            skipPager: true,
          })
          .then(() => {
            callback(null, this.companies);
          });
      },
      openWishList(userId) {
        this.$router.push({
          name: 'EditWishList',
          params: { id: userId },
        });
      },
      getWishLists() {
        this.$store.dispatch(this.actionName, {
          ...this.searchConfig,
          ...this.paginationProps,
          page: 1,
        });
  
        this.$router
          .push({
            query: {
              ...this.paginationProps,
              page: 1,
            },
          })
          .catch(() => {});
      },
    },
    mounted() {
      const { query } = this.$route;
  
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: query?.page ? parseInt(query.page, 10) : 1,
      });
      this.$store.dispatch('getCompanies', {
        sortBy: 'title',
        isSortAscending: true,
        retrieveAll: true,
        skipPager: true,
      });
    },
    watch: {
      companyId() {
        this.getWishLists();
      },
      b2bOrb2c() {
        this.getWishLists();
      },
    },
  };
  </script>
  
  <style>
  .vue-treeselect__placeholder {
    color: #000;
  }
  
  .form-control.form-control-modern.vue-treeselect.vue-treeselect--open-below.vue-treeselect--searchable.vue-treeselect--single.w-25 {
    height: 46px;
  }
  
  .vue-treeselect__control {
    border: none;
    background: none;
  }
  </style>
  <style lang="scss" scoped>
  .sorting {
    cursor: pointer;
  }
  
  tbody tr {
    cursor: pointer;
  }
  </style>
  